import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../api/client';
import type { CreateDeviceRequest, DeviceDto, UpdateDeviceRequest } from './types';

const QK_LIST = ['devices'] as const;

export function useDevices() {
  return useQuery({
    queryKey: QK_LIST,
    queryFn: async () => (await apiClient.get<DeviceDto[]>('/api/devices')).data,
  });
}

export function useCreateDevice() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (request: CreateDeviceRequest) =>
      (await apiClient.post<DeviceDto>('/api/devices', request)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: QK_LIST }),
  });
}

export function useUpdateDevice() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, request }: { id: string; request: UpdateDeviceRequest }) =>
      (await apiClient.put<DeviceDto>(`/api/devices/${id}`, request)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: QK_LIST }),
  });
}

export function useDeleteDevice() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await apiClient.delete(`/api/devices/${id}`);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: QK_LIST }),
  });
}
